import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals'
import { debugLog } from '@/utils/logger'

type WebVitalMetric = {
  name: string
  value: number
  rating: string
}

function publishMetric(metric: WebVitalMetric) {
  debugLog('[web-vitals]', metric.name, metric.value, metric.rating)
  window.dispatchEvent(
    new CustomEvent('nastaliqart:web-vital', {
      detail: metric,
    })
  )
}

export function startWebVitals() {
  onCLS(({ name, value, rating }) => publishMetric({ name, value, rating }))
  onFCP(({ name, value, rating }) => publishMetric({ name, value, rating }))
  onINP(({ name, value, rating }) => publishMetric({ name, value, rating }))
  onLCP(({ name, value, rating }) => publishMetric({ name, value, rating }))
  onTTFB(({ name, value, rating }) => publishMetric({ name, value, rating }))
}
